import React from 'react';
import classNames from 'classnames';

import Icons from 'assets/icons';

import { getTestId } from 'helpers/test-helpers';

import type { MetricCardData } from '../results-step.types';

interface MetricCardProps {
  card: MetricCardData;
  actualYearLabel?: string;
  isLoading?: boolean;
}

const MetricCard = ({
  card,
  actualYearLabel = 'Actual',
  isLoading = false,
}: MetricCardProps): React.JSX.Element => (
  <div
    className="relative flex flex-1 flex-col gap-1 rounded-md border border-navy-200 bg-white px-4 py-3 overflow-hidden"
    data-testid={getTestId({
      prefix: 'results-metric-card',
      label: card.key,
    })}
  >
    <div
      className={classNames(
        'flex flex-col gap-1 transition-[filter] duration-200',
        isLoading && 'blur-[2px]'
      )}
    >
      <span className="text-sm font-semibold text-gray-500">{card.label}</span>
      <span className="text-xl font-bold text-navy-800">{card.value}</span>
      {card.originalValue && (
        <span className="text-xs text-gray-500">
          Original: <span className="font-medium">{card.originalValue}</span>
        </span>
      )}
      {card.actualValue && (
        <span
          className="text-xs text-gray-500"
          data-testid={getTestId({
            prefix: 'results-metric-card',
            label: card.key,
            suffix: 'actual',
          })}
        >
          {actualYearLabel}:{' '}
          <span className="font-medium">{card.actualValue}</span>
        </span>
      )}
    </div>
    {isLoading && (
      <div className="absolute inset-0 flex items-center justify-center">
        <Icons.Spinner className="size-5 animate-spin text-gray-300 fill-navy-600" />
      </div>
    )}
  </div>
);

export default MetricCard;
